import { EBookingStatus } from '../../../enums/booking.enum';
import { ESmallFleetOrderStatus } from '../../../enums/small-fleet-orders.enum';
import { IOrder } from '../../../interfaces/order.interface';
import { IRequest } from '../../../interfaces/requests.interface';

const STATUS_MAPPING: Record<ESmallFleetOrderStatus, string[]> = {
    [ESmallFleetOrderStatus.PENDING]: [EBookingStatus.READY_FOR_PICKUP, EBookingStatus.ON_HOLD],
    [ESmallFleetOrderStatus.ASSIGNED]: [
        EBookingStatus.ACCEPTED,
        EBookingStatus.ARRIVED_AT_PICKUP,
        EBookingStatus.ARRIVED_AT_DELIVERY,
        EBookingStatus.WAY_TO_DELIVER,
        EBookingStatus.RETURNING,
        EBookingStatus.COMPLETED,
    ],
    [ESmallFleetOrderStatus.LOST]: [
        EBookingStatus.NOT_DELIVERED,
        EBookingStatus.RETURNED,
        EBookingStatus.PROVIDER_NOT_FOUND,
        EBookingStatus.CANCELLED,
        EBookingStatus.CANCELLED_BY_DRIVER,
        EBookingStatus.CANCELLED_BY_CUSTOMER,
        EBookingStatus.CANCELLED_BY_DELIVERY_PROVIDER,
        EBookingStatus.CANCELLED_BY_ADMIN,
        EBookingStatus.CANCELLED_BY_BUSINESS,
    ],
};

export const getStatusText = (status: string, workspaceName: string, providerName: string) => {
    const isSameProvider = workspaceName === providerName;
    let statusText;

    switch (status) {
    case EBookingStatus.READY_FOR_PICKUP:
    case EBookingStatus.ON_HOLD:
        statusText = ESmallFleetOrderStatus.PENDING;
        break;
    case EBookingStatus.ACCEPTED:
    case EBookingStatus.ARRIVED_AT_PICKUP:
    case EBookingStatus.ARRIVED_AT_DELIVERY:
    case EBookingStatus.WAY_TO_DELIVER:
    case EBookingStatus.RETURNING:
    case EBookingStatus.COMPLETED:
        statusText = ESmallFleetOrderStatus.ASSIGNED;
        break;
    case EBookingStatus.NOT_DELIVERED:
    case EBookingStatus.RETURNED:
    case EBookingStatus.PROVIDER_NOT_FOUND:
    case EBookingStatus.CANCELLED:
    case EBookingStatus.CANCELLED_BY_DRIVER:
    case EBookingStatus.CANCELLED_BY_CUSTOMER:
    case EBookingStatus.CANCELLED_BY_DELIVERY_PROVIDER:
    case EBookingStatus.CANCELLED_BY_ADMIN:
    case EBookingStatus.CANCELLED_BY_BUSINESS:
        statusText = ESmallFleetOrderStatus.LOST;
        break;
    default:
        statusText = ESmallFleetOrderStatus.PENDING;
        break;
    }

    if (statusText === ESmallFleetOrderStatus.ASSIGNED && isSameProvider) {
        statusText = ESmallFleetOrderStatus.ASSIGNED;
    } else if (statusText === ESmallFleetOrderStatus.ASSIGNED && !isSameProvider) {
        statusText = ESmallFleetOrderStatus.LOST;
    }

    return statusText;
};

export const getStatusArrayBySmallFleetStatus = (smallFleetStatus: ESmallFleetOrderStatus): string[] => STATUS_MAPPING[smallFleetStatus] || [];

export const getStatusArrayBySmallFleetStatuses = (
    smallFleetStatuses: ESmallFleetOrderStatus[],
): string[] => smallFleetStatuses.flatMap((status) => STATUS_MAPPING[status] || []);

export const getSmallFleetStatusesFromArray = (statusArray: string[]): ESmallFleetOrderStatus[] => (!statusArray?.length
    ? []
    : (Object.entries(STATUS_MAPPING) as [ESmallFleetOrderStatus, string[]][])
        .filter(([, statuses]) => statuses.every((status) => statusArray.includes(status)))
        .map(([smallFleetStatus]) => smallFleetStatus));

export const mapperOrderToRequest = (order: IOrder): IRequest => ({
    _id: order._id,
    bookingID: order.rideId,
    bookingNumericId: order.rideNumericId,
    orderNumericId: order.orderNumericId,
    isActive: order.isActive,
    status: order.status,
    providerName: order.providerName,
    businessName: order.businessName ?? '',
    customerName: order.customerName ?? '',
    createdAt: order.createdAt,
    updatedAt: order.updatedAt,
});
